const navMenuTitles = {
  Uspqrp: 'USPQRP',
  Provider: 'Proveedor',
  Medicaid: 'Medicaid',
};

export default navMenuTitles;
